import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncMaterialIconTwoTone = createAsyncIcon(() => import('./MaterialIconTwoTone'));

export default AsyncMaterialIconTwoTone;

AsyncMaterialIconTwoTone.displayName = 'AsyncMaterialIconTwoTone';
